import { render, staticRenderFns } from "./BreadModelAddDialog.vue?vue&type=template&id=2da05c1d&scoped=true&"
import script from "./BreadModelAddDialog.vue?vue&type=script&lang=js&"
export * from "./BreadModelAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./BreadModelAddDialog.vue?vue&type=style&index=0&id=2da05c1d&scoped=true&lang=css&"
import style1 from "./BreadModelAddDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da05c1d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
